import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useSelected, useFocused } from 'slate-react';
var Image = function Image(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    element = _ref.element,
    attrs = _ref.attrs;
  var selected = useSelected();
  var focused = useFocused();
  var shadow = selected && focused ? '0 0 0 3px #B4D5FF' : 'none'; // feedback to show image as selected

  delete attrs['data-slate-node'];
  attrs.style = _objectSpread2(_objectSpread2({}, attrs.style), {
    boxShadow: shadow
  });
  return /*#__PURE__*/React.createElement("div", attributes, children, /*#__PURE__*/React.createElement("div", {
    contentEditable: false
  }, /*#__PURE__*/React.createElement("img", _extends({}, attrs, {
    src: element.url || element.src
  }))));
};
Image.displayName = "Image";
export { Image };